import React, { FC, useContext } from 'react'

import { Photos } from 'components/page/ForeignProfile/common.types'
import { ForeignPhotoContext } from 'components/page/ForeignProfile/ForeignProfile.constants'
import { skipEndPointIncognito } from 'components/page/ForeignProfile/Photos/function/skipEndPointIncogito'
import {
  Image,
  ImageSquare,
  ImageSquareLarge,
  WrapperImagesInline,
} from 'components/page/ForeignProfile/Photos/Photos.styled'

export const PhotosTile: FC<{ photos: Photos }> = ({ photos }) => {
  const { baseHrefPhoto, useAuthorizationUrl } = useContext(ForeignPhotoContext)

  if (photos.length === 3) {
    const [firstPhoto, secondPhoto, thirdPhoto] = photos
    return (
      <>
        <WrapperImagesInline>
          <ImageSquare
            key={firstPhoto.photoId}
            to={skipEndPointIncognito(
              baseHrefPhoto,
              firstPhoto.photoId,
              useAuthorizationUrl
            )}
            data-name={`photoviewer-${firstPhoto.photoId}-action`}
          >
            <Image
              src={firstPhoto.urls.square}
              data-name={`photoviewer-${firstPhoto.photoId}-photo`}
              $coordinates={firstPhoto.faceCenter}
            />
          </ImageSquare>
          <ImageSquare
            key={secondPhoto.photoId}
            to={skipEndPointIncognito(
              baseHrefPhoto,
              secondPhoto.photoId,
              useAuthorizationUrl
            )}
            data-name={`photoviewer-${secondPhoto.photoId}-action`}
          >
            <Image
              src={secondPhoto.urls.square}
              data-name={`photoviewer-${secondPhoto.photoId}-photo`}
              $coordinates={secondPhoto.faceCenter}
            />
          </ImageSquare>
        </WrapperImagesInline>
        <ImageSquareLarge
          key={thirdPhoto.photoId}
          to={skipEndPointIncognito(
            baseHrefPhoto,
            thirdPhoto.photoId,
            useAuthorizationUrl
          )}
          data-name={`photoviewer-${thirdPhoto.photoId}-action`}
        >
          <Image
            src={thirdPhoto.urls.squareLarge}
            data-name={`photoviewer-${thirdPhoto.photoId}-photo`}
            $coordinates={thirdPhoto.faceCenter}
          />
        </ImageSquareLarge>
      </>
    )
  } else {
    return (
      <>
        {photos.map(({ photoId, urls: { squareLarge }, faceCenter }) => (
          <ImageSquareLarge
            key={photoId}
            to={skipEndPointIncognito(
              baseHrefPhoto,
              photoId,
              useAuthorizationUrl
            )}
            data-name={`photoviewer-${photoId}-action`}
          >
            <Image
              src={squareLarge}
              data-name={`photoviewer-${photoId}-photo`}
              $coordinates={faceCenter}
            />
          </ImageSquareLarge>
        ))}
      </>
    )
  }
}
